import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _DocumentFactory, _single } from "../../../core/services/dataBean/EntityCatalog";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicTable, MASK_MONEY } from "../../theme/Component/BasicTable";
import { _AdquisitionContractByAdquisition, _AdquisitionItemByPaa } from "../../../core/services/dataBean/EntityCatalogVdos";
import { BasicPage } from "../../theme/Component/BasicPage";



interface Props {
    idProject: any;
}

export const AdquisitionContractByAdquisition = ({ idProject }: Props) => {

    const byadquisition = useDataBean(_AdquisitionContractByAdquisition);
    const [lista, setLista] = useState<any>([]);
    const paginador = usePaginator();

    useEffect(() => {
        getListavdos();
    }, [paginador.page, idProject])

    const head = [
        { title: 'ID', property: 'IDAdquisitionContract', visible: true },
        { title: 'ID PAA', property: 'IDAdquisitionItem', visible: true },
        { title: 'Fecha Contrato', property: 'AdquisitionContractDate', visible: true },
        { title: 'Código Contrato', property: 'InternalCode', visible: true },
        { title: 'Identificación Proveedor', property: 'AccountID', visible: true },
        { title: 'Nombre Proveedor', property: 'AccountName', visible: true, mask: MASK_MONEY },
        { title: 'Valor Contratado', property: 'ContractValue', visible: true, mask: MASK_MONEY },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Justificación', property: 'Justification', visible: true },
    ]

    const getListavdos = () => {

        byadquisition.instance.getAdquisitionContractByProject(idProject, null, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    return (
        <div className="row">
            <BasicPage titulo="Contratos de Adquisición">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={byadquisition.setBean} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                </div>
            </BasicPage>


        </div>
    )
}